import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ManageUsersPanel from "./manageUsersPanel.tsx";
import { Link } from "react-router-dom";


export default function Admin() {
    return (
        <Container className="my-4 pt-2 pb-2">
            <Row className='mb-4 align-items-center'>
                <Col>
                    <h2 className='mb-0'>Admin Management</h2>
                    <p className='text-muted'>Manage user accounts and permissions.</p>
                </Col>
                <Col xs='auto'>
                    <Link to='/home' className='btn btn-outline-secondary btn-sm'>
                        Back to Home
                    </Link>
                </Col>
            </Row>

            <ManageUsersPanel owner={false} />
        </Container>
    );
}